import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

interface Produto {
  codigo: string;
  nome: string;
  categoria: string;
  preco: number;
  estoque: number;
  status: string;
}

@Component({
  selector: 'app-produtos',
  templateUrl: './produtos.component.html',
  styleUrls: ['./produtos.component.scss']
})
export class ProdutosComponent implements OnInit {
  produtos: Produto[] = [
    {
      codigo: 'PRD-001',
      nome: 'Mesa de Escritório',
      categoria: 'Móveis',
      preco: 599.90,
      estoque: 15,
      status: 'Ativo'
    },
    {
      codigo: 'PRD-002',
      nome: 'Cadeira Ergonômica',
      categoria: 'Móveis',
      preco: 899.90,
      estoque: 20,
      status: 'Ativo'
    },
    {
      codigo: 'PRD-003',
      nome: 'Armário de Arquivo',
      categoria: 'Móveis',
      preco: 1299.90,
      estoque: 8,
      status: 'Ativo'
    },
    {
      codigo: 'PRD-004',
      nome: 'Estante Modular',
      categoria: 'Móveis',
      preco: 799.90,
      estoque: 12,
      status: 'Ativo'
    },
    {
      codigo: 'PRD-005',
      nome: 'Mesa de Reunião',
      categoria: 'Móveis',
      preco: 2499.90,
      estoque: 5,
      status: 'Ativo'
    }
  ];

  // Propriedades para os filtros
  filtroNome: string = '';
  filtroCategoria: string = '';
  filtroStatus: string = '';

  // Propriedades para o modal
  selectedProduct: Produto | null = null;
  newStockQuantity: number = 0;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  openUpdateStockModal(content: any, produto: Produto) {
    this.selectedProduct = produto;
    this.newStockQuantity = produto.estoque;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  updateStock() {
    if (this.selectedProduct && this.newStockQuantity >= 0) {
      // Atualiza o estoque do produto
      this.selectedProduct.estoque = this.newStockQuantity;
      
      // Aqui você pode adicionar a lógica para salvar no backend
      console.log('Estoque atualizado:', this.selectedProduct);
      
      // Fecha o modal
      this.modalService.dismissAll();
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      // Verifica se o arquivo é do tipo Excel
      if (file.type === 'application/vnd.ms-excel' || 
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        // Aqui você pode implementar a lógica para processar o arquivo Excel
        console.log('Arquivo selecionado:', file.name);
        // TODO: Implementar a lógica de upload e processamento do arquivo
      } else {
        alert('Por favor, selecione um arquivo Excel (.xls ou .xlsx)');
      }
    }
  }
} 